import esriRequest from "@arcgis/core/request";
import { eachAlways } from "@arcgis/core/core/promiseUtils";
import { substitute } from "@arcgis/core/intl";
import moment from "moment";
import { isEnterprise } from "./appUtils";

export function fetchNotifications(portal, t9n) {
  const homeAppRootUrl = portal.restUrl.replace("sharing/rest", "home") + "/";

  return portal.fetchNotifications().then((results) => {
    return (results || [])
      .filter(
        (notification) =>
          notification && notification.type !== "message_received"
      )
      .filter((notification) => t9n.notifications.types[notification.type])
      .map((notification) => {
        notification.data = {
          ...notification.data,
          ...{ homeAppRootUrl: homeAppRootUrl },
        };
        return _formatNotification(notification, portal, t9n);
      });
  });
}

export function _formatNotification(notification, portal, t9n) {
  if (notification.type === "webapp_not_copied" && isEnterprise(portal)) {
    notification.type = "webapp_not_copied_portal";
  }
  return {
    text: substitute(
      t9n.notifications.types[notification.type],
      notification.data
    )
      .split("$")
      .join(""),
    date: moment(notification.received).fromNow(),
    id: notification.id,
  };
}

export function deleteNotifications(portalUrl, user, ids) {
  const deleted = ids
    .map((id) => ({ username: user.username, portalUrl: portalUrl, id }))
    .map(_deleteNotification);
  return eachAlways(deleted);
}

function _deleteNotification(options) {
  const { portalUrl, username, id } = options;
  const url = `${portalUrl}community/users/${username}/notifications/${id}/delete`;
  return esriRequest(url, {
    method: "post",
    responseType: "json",
    query: { f: "json" },
  });
}
